import {Component, Input, OnInit} from '@angular/core';
import {OwlMultiSliderConfigService} from "../../home/service/owl-multi-slider-config.service";
import {OwlOptions} from "ngx-owl-carousel-o";
import {StoryPreview} from "../../story/interface/story-preview";
import {RequestMapperService} from "../../request-mapper.service";
import {StoryTransmissionService} from "../../raintree/transmission/story-transmission.service";
import {CartCalculationService} from "../../cart/service/cart-calculation.service";

@Component({
	selector: 'fb-content-slider',
	templateUrl: './content-slider.component.html',
	styleUrls: ['./content-slider.component.scss']
})
export class ContentSliderComponent implements OnInit {

	@Input() id: string = '';
	public customOptions: OwlOptions = OwlMultiSliderConfigService.owlOptionsSingleSlide;
	public storyPreview: StoryPreview[] = [];

	public craftStory: StoryPreview[] = [];
	public clusterStory: StoryPreview[] = [];
	public collabStory: StoryPreview[] = [];
	public artistStory: StoryPreview[] = [];

	constructor(
		private _cartCalculation: CartCalculationService,
		private _storyTransmissionService: StoryTransmissionService,
	) {
	}

	public ngOnInit(): void {
		this.fetchContentList()
	}
	public fetchContentList(): void {
		let id: number = (this._cartCalculation.finishedProductId ? this._cartCalculation.finishedProductId : this._cartCalculation.fabricProductId) || 0;
		this._storyTransmissionService.getStoryList(

			RequestMapperService.GET_RELATED_STORY_IN_PRODUCT_DETAILS + id,
			(): void => {
			},
			(response: StoryPreview[]): void => {

				this.storyPreview = response;
				this.filterStoryList(response)
			},
			(): void => {
			},
			(error: string): void => {
			},
			(): void => {
			}
		)
	}

	public filterStoryList(storyList: StoryPreview[]): void {

		storyList.forEach((story: StoryPreview) => {

			if (story.storyContentCategory.storyContentType === 'CRAFTS') this.craftStory.push(story)
			if (story.storyContentCategory.storyContentType === 'CLUSTERS') this.clusterStory.push(story)
			if (story.storyContentCategory.storyContentType === 'COLLABORATIONS') this.collabStory.push(story)
			if (story.storyContentCategory.storyContentType === 'ARTISTS') this.artistStory.push(story)
		})

	}
}
